




import { Component, Mixins, Prop } from "vue-property-decorator";
import { Rectangle, Point, Size } from "../../../domain/drawing";
import { IDrawableItem, instanceOfIRelayoutHeightSpecifiable } from "../../../domain/document/items";

@Component({
})
export default class FocusIndicator extends Mixins() {
  @Prop()
  source: IDrawableItem;

  get isFocused(): boolean {
    return !!this.source && !!this.source.geometry && !!this.source.geometry.rectangle;
  }

  get rectangle(): Rectangle {
    return this.isFocused
      ? instanceOfIRelayoutHeightSpecifiable(this.source) && this.source.relayoutHeight !== null
        ? new Rectangle(this.source.geometry.rectangle.topLeft, new Size(this.source.geometry.rectangle.width, this.source.relayoutHeight))
        : this.source.geometry.rectangle
      : new Rectangle(new Point(0, 0), new Size(0, 0));
  }

  get geometryProperties(): any {
    return {
      position: "absolute",
      top: this.rectangle.topLeft.y + "px",
      left: this.rectangle.topLeft.x + "px",
      width: this.rectangle.size.width + "px",
      height: this.rectangle.size.height + "px",
    };
  }

  get outlineProperties() {
    return {
      outline: this.$configuration.style.document.editor.focusIndicator.borderWidth + "px rgba(255, 0, 0, 0.5) solid",
    };
  }
}
